import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import * as FilePond from 'filepond';

export default class ScansReportsUploadComponent extends Component {
  pond = null;

  @tracked stagedFiles = [];
  @tracked isUploading = false;
  @tracked publishedFiles = [];

  @action
  async loadPublishedFiles() {
    if (!this.args.publishedReportsUrl) return;
    const response = await fetch(this.args.publishedReportsUrl);
    const text = await response.text();
    const xml = new DOMParser().parseFromString(text, 'application/xml');
    this.publishedFiles = [...xml.querySelectorAll('Contents')].map((el) => {
      const key = el.querySelector('Key')?.textContent ?? '';
      return {
        key,
        name: key.split('/').pop() ?? key,
        size: Number(el.querySelector('Size')?.textContent ?? 0),
        lastModified: el.querySelector('LastModified')?.textContent ?? '',
      };
    });
  }

  @action
  setupPond(element) {
    void this.loadPublishedFiles();
    this.pond = FilePond.create(element, {
      allowMultiple: true,
      disabled: this.args.disabled ?? false,
      credits: false,
      labelIdle:
        'Drag & drop report files or <span class="filepond--label-action">Browse</span>',
      onaddfile: (error, file) => {
        if (!error) {
          this.stagedFiles = [...this.stagedFiles, file];
        }
      },
      onremovefile: (error, file) => {
        if (!error) {
          this.stagedFiles = this.stagedFiles.filter((f) => f.id !== file.id);
        }
      },
    });
  }

  @action
  async upload() {
    if (!this.stagedFiles.length || this.isUploading) return;
    this.isUploading = true;
    try {
      await this.args.onUpload?.(this.stagedFiles);
      this.stagedFiles = [];
      this.pond?.removeFiles();
      await this.loadPublishedFiles();
    } finally {
      this.isUploading = false;
    }
  }

  willDestroy() {
    super.willDestroy(...arguments);
    this.pond?.destroy();
    this.pond = null;
  }
}
